import { render, staticRenderFns } from "./BarcodeDisplay.vue?vue&type=template&id=5f5d34b4&scoped=true"
import script from "./BarcodeDisplay.vue?vue&type=script&lang=js"
export * from "./BarcodeDisplay.vue?vue&type=script&lang=js"
import style0 from "./BarcodeDisplay.vue?vue&type=style&index=0&id=5f5d34b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d34b4",
  null
  
)

export default component.exports